import * as React from 'react';
import { useState } from "react";
import Box from '@mui/material/Box';
import { Divider, Paper, Stack, Typography } from '@mui/material';
import ParentBox from '../components/ParentBox';
import DashboardMap from 'map/DashboardMap';
import Spinner from 'map/Spinner';
import { useWebSocket } from 'utils/useWebSocket';
import { getWebsocketHost, repeatEffect, settingsConfig } from 'utils/commonFunc';
import { EmergencyVehicleInfoBox } from '../components/EmergencyVehicleInfoBox';
import ApiService from "services/ApiService";
import styles from '../css/gis.module.css';
import defColors from 'utils/defColors';
import { WeatherPaper } from '../components/WeatherPaper';
import TrafficColorTableBox from '../components/TrafficColorTableBox';
import GisLayerCheck from '../components/GisLayerCheck.js';
import { GisLayerList, AllLayerList } from 'map/layers/GisLayerInfo';
import { useDashboard } from '../components/DashboardContext';
import { toLonLat, fromLonLat } from 'ol/proj';
import { sharedCamera, useCctvContext } from '../sharedCamera'
import Slider from "@mui/material/Slider";
import IconButton from '@mui/material/IconButton';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import StopIcon from '@mui/icons-material/Stop';
import PauseIcon from '@mui/icons-material/Pause';
// 근깁차량 에뮬레이터
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
// 근깁차량 에뮬레이터
const Item = styled(Button)(({ theme }) => ({
    width: '20vw',
    height: '6vmin',
    fontSize: '2vmin'
}));
// 근깁차량 에뮬레이터
const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function GisView({ setEmergencyVehicleMode }) {

    const mapRef = React.useRef();
    const [link2GeoJson, setLink2GeoJson] = React.useState();
    const [currentLink2Data, setCurrentLink2Data] = React.useState();
    const [emergencyVehicleArr, setEmergencyVehicleArr] = React.useState({})
    const [vehicleItems, setVehicleItems] = React.useState()
    const [passengerData, setPassengerData] = React.useState()
    const [inOutTrfData, setInOutTrfData] = React.useState()
    const [hazaData, setHazaData] = React.useState()

    const [menuIndex, setMenuIndex] = useState(0);
    const [layerIndex, setLayerIndex] = useState(menuIndex);
    const [layerList, setLayerList] = useState(GisLayerList);
    const [selLayerList, setSelLayerList] = useState(layerList[menuIndex]);
    const [allLayerList, setAllLayerList] = useState(AllLayerList);
    const { activeView, mapMessages } = useDashboard();

    // 체크박스 map.setView 용
    const [selectedLayer, setSelectedLayer] = useState(null);

    // 도로소통히트맵
    const timerRef = React.useRef();
    const [timerIndex, setCurrentTimeIndex] = React.useState(0);
    const [timerPlaying, setTimerPlaying] = React.useState(false);
    const [timerDate, setTimerDate] = React.useState(getToday());

    // 버스히트맵 isDataLoaded
    const [loaded1, setLoaded1] = React.useState()
    const [loaded2, setLoaded2] = React.useState()
    const [loaded3, setLoaded3] = React.useState()

    // 긴급차량 에뮬레이터
    const [open, setOpen] = React.useState({ message: '', open: false, severity: 'success' });
    // 자율주행 에뮬레이터 비디오 옵션용
    const [videoOpen, setVideoOpen] = React.useState(false);
    //카메라 관리용
    const { updateActiveCctv } = useCctvContext();

    // 긴급차량
    useWebSocket(
        {
            url: getWebsocketHost('/websocket/emergencyvehicle', window.serviceConfig.wsPortEmergencyVehicle),
            messageCallback: (e) => {
                const map = mapRef.current
                const recvJson = JSON.parse(e.data)
                if (recvJson.serviceId && map) {
                    const protocolData = recvJson;
                    protocolData.expiredTime = Date.now()
                    setEmergencyVehicleArr(prev => {
                        const result = { ...prev }
                        result[protocolData.serviceId] = { ...result[protocolData.serviceId], ...protocolData };
                        for (const property in result) {
                            const curProtocolData = result[property]
                            if (curProtocolData.expired || (Date.parse(curProtocolData.expiredTime) < Date.now())) {
                                map.RemoveEmergencyVehicleRoute(curProtocolData)
                                Reflect.deleteProperty(result, property);
                            }
                        }
                        setEmergencyVehicleMode && setEmergencyVehicleMode(result)
                        return result
                    })
                    if (!protocolData.expired)
                        map.AddEmergencyVehicleRoute(protocolData)
                }
            },
            openCallback: null,
            closeCallback: () => {
                const map = mapRef.current
                if (map) {
                    setEmergencyVehicleArr(prev => {
                        const result = { ...prev }
                        for (const property in result) {
                            const curProtocolData = result[property]
                            map.RemoveEmergencyVehicleRoute(curProtocolData)
                        }
                        setEmergencyVehicleMode && setEmergencyVehicleMode({})
                        return {}
                    })
                }
            }
        }
    )
    // 링크
    React.useEffect(() => {
        ApiService.get("dashboard/Map/GeoJson").then(response => {
            if (response.status === 200) {
                const data = response.data;
                setLink2GeoJson(data.link2)
            }
        })
    }, []);
    // 도로소통정보
    React.useEffect(() => {
        if (!link2GeoJson)
            return

        return repeatEffect(
            async () => {
                const response = await ApiService.get("dashboard/Map/UpdateLink2Data")
                if (response.status === 200) {
                    const data = response.data;
                    setCurrentLink2Data(data)
                }
            },
            settingsConfig().contentUpdateDelaySec)
    }, [link2GeoJson]);
    // 유출입
    React.useEffect(() => {
        return repeatEffect(
            async () => {
                const response = await ApiService.get("newdashboard/integrated/GetInOutTraffic");
                if (response.status === 200) {
                    if (!response.data.rows || response.data.rows?.length < 1) {
                        return;
                    }
                    const data = response.data.rows[0];
                    const targetDef = [
                        { id: 'eW01', displayTitle: '의왕,군포', xyOpen: [126.984492, 37.343971], xyRoute: [126.993470, 37.323810], positioning: 'bottom-right' },
                        { id: 'yI01', displayTitle: '용인,성남', xyOpen: [127.073692, 37.348052], xyRoute: [127.049300, 37.306970], positioning: 'bottom-right' },
                        { id: 'yI02', displayTitle: '용인,수지', xyOpen: [127.142356, 37.319988], xyRoute: [127.050580, 37.294210], positioning: 'bottom-left' },
                        { id: 'yI03', displayTitle: '용인,기흥', xyOpen: [127.157653, 37.255538], xyRoute: [127.057000, 37.270210], positioning: 'bottom-left' },
                        { id: 'yI04', displayTitle: '화성,동탄', xyOpen: [127.134064, 37.238521], xyRoute: [127.0662460, 37.247323], positioning: 'top-left' },
                        { id: 'hS01', displayTitle: '화성,봉담', xyOpen: [127.01612, 37.217391], xyRoute: [127.006950, 37.240580], positioning: 'top-center' },
                        { id: 'hS02', displayTitle: '화성,안산', xyOpen: [126.912182, 37.228543], xyRoute: [126.969730, 37.250800], positioning: 'top-right' }
                    ];
                    const updatedData = targetDef.map(p => {
                        Object.entries(data).forEach(([key, value]) => {
                            if (key.includes(p.id) && key.includes("IN")) p.inve = value;
                            if (key.includes(p.id) && key.includes("OUT")) p.outve = value;
                        });
                        return p;
                    });
                    setInOutTrfData(updatedData);
                }
            },
            settingsConfig().bisMapUpdateDelaySec ?? settingsConfig().contentUpdateDelaySec)
    }, []);
    // 위험물차량
    React.useEffect(() => {
        return repeatEffect(
            async () => {
                const response = await ApiService.get("newdashboard/gis/GetDangerVehicle");
                if (response.status === 200) {
                    const data = response.data;
                    setHazaData(data);
                }
            },
            30)
    }, []);
    // 버스차량
    React.useEffect(() => {
        return repeatEffect(
            async () => {
                const response = await ApiService.get("dashboard/bis/GetVehicle");
                if (response.status === 200) {
                    const data = response.data;
                    setVehicleItems(data);
                }
            },
            settingsConfig().bisMapUpdateDelaySec ?? settingsConfig().contentUpdateDelaySec)
    }, []);
    // 승하차인원현황
    React.useEffect(() => {
        return repeatEffect(
            async () => {
                const response = await ApiService.get("newdashboard/gis/GetBusPssngrData");
                if (response.status === 200) {
                    const data = response.data.pssngr;
                    setPassengerData(data);
                }
            },
            settingsConfig().bisMapUpdateDelaySec ?? settingsConfig().contentUpdateDelaySec)
    }, []);
    // 메뉴
    React.useEffect(() => {

        let tmpAllLayerList = [...allLayerList];
        for (let i = 0; i < tmpAllLayerList.length; i++) {
            tmpAllLayerList[i].checked = false;
        }
        let tmpLayerList = [...layerList];
        for (let i = 0; i < tmpLayerList.length; i++) {
            for (let j = 0; j < tmpLayerList[i].length; j++) {
                tmpLayerList[i][j].checked = false;
                tmpLayerList[i][j].disabled = false;
            }
        }
        let vdsLayer, dsrcLayer, cctvLayer, vmsLayer, trfInfLayer, linkLayer, inoutLayer, parkLayer, linkHeatLayer;
        let crsrLayer, sgnInfLayer, emerLayer, signLayer;
        let busLayer, stopLayer, bitLayer, busHeatLayer, bisSvrStatLayer;
        let surfLayer, hazaLayer, schoolZoneLayer;
        let selfLinkLayer, selfVhcLayer;

        const map = mapRef.current

        switch (activeView) {
            case 'integratedControl': // 통합관제
                linkLayer = tmpAllLayerList.find(x => x.layer === 'linkLayer'); if (linkLayer) { linkLayer.checked = true; tmpLayerList[0][5].checked = true; tmpLayerList[0][5].disabled = false; }
                // if(map) { map.SetMapView(13.5, 127.03804, 37.2695); }
                if (map) { map.SetMapView(13.5, 127.00454, 37.28195); }
                setMenu(0);
                break;
            case 'roadTraffic': // 토로소통
                linkLayer = tmpAllLayerList.find(x => x.layer === 'linkLayer'); if (linkLayer) { linkLayer.checked = true; tmpLayerList[0][5].checked = true; tmpLayerList[0][5].disabled = false; }
                // if(map) { map.SetMapView(13.5, 127.03804, 37.2695); }
                if (map) { map.SetMapView(13.5, 127.00454, 37.28195); }
                setMenu(0);
                break;
            // case 'signalOperation':
            case 'SignalOperationViewTest': // 신호운영
                crsrLayer = tmpAllLayerList.find(x => x.layer === 'crsrLayer'); if (crsrLayer) { crsrLayer.checked = true; tmpLayerList[1][0].checked = true; tmpLayerList[1][0].disabled = false; }
                // if(map) { map.SetMapView(13.5, 127.03804, 37.2695); }
                if (map) { map.SetMapView(13.5, 127.00454, 37.28195); }
                setMenu(1);
                break;
            case 'busOperation': // 버스운행
                busLayer = tmpAllLayerList.find(x => x.layer === 'busLayer'); if (busLayer) { busLayer.checked = true; tmpLayerList[2][0].checked = true; tmpLayerList[2][0].disabled = false; }
                // if(map) { map.SetMapView(13.5, 127.03804, 37.2695); }
                if (map) { map.SetMapView(13.5, 127.00454, 37.28195); }
                setMenu(2);
                break;
            case 'trafficSafety': // 교통안전
                hazaLayer = tmpAllLayerList.find(x => x.layer === 'hazaLayer'); if (hazaLayer) { hazaLayer.checked = true; tmpLayerList[3][1].checked = true; tmpLayerList[3][1].disabled = false; }
                // schoolZoneLayer = tmpAllLayerList.find(x => x.layer === 'schoolZoneLayer'); if(schoolZoneLayer) { schoolZoneLayer.checked = true; tmpLayerList[3][2].checked = true; tmpLayerList[3][2].disabled = false; }                
                // if(map) { map.SetMapView(13.5, 127.03804, 37.2695); }
                if (map) { map.SetMapView(13.5, 127.00454, 37.28195); }
                setMenu(3);
                break;
            case 'futureTransportation': // 미래교통
                selfLinkLayer = tmpAllLayerList.find(x => x.layer === 'selfLinkLayer'); if (selfLinkLayer) { selfLinkLayer.checked = true; tmpLayerList[4][0].checked = true; tmpLayerList[4][0].disabled = false; }
                selfVhcLayer = tmpAllLayerList.find(x => x.layer === 'selfVhcLayer'); if (selfVhcLayer) { selfVhcLayer.checked = true; tmpLayerList[4][1].checked = true; tmpLayerList[4][1].disabled = false; }
                if (map) { map.SetMapView(16, 127.05504, 37.28995); }
                setMenu(4);
                break;
            default:
                break;
        }
        setAllLayerList(tmpAllLayerList);
        setLayerList(tmpLayerList);
    }, [activeView]);

    React.useEffect(() => {
        const handleKeyUp = (event) => {
            if (event.ctrlKey && event.code === 'ArrowLeft') {

                let tmpAllLayerList = [...allLayerList];
                for (let i = 0; i < tmpAllLayerList.length; i++) {
                    tmpAllLayerList[i].checked = false;
                }
                setAllLayerList(tmpAllLayerList);

                let tmpLayerList = [...layerList];
                for (let i = 0; i < tmpLayerList.length; i++) {
                    for (let j = 0; j < tmpLayerList[i].length; j++) {
                        tmpLayerList[i][j].checked = false;
                    }
                }
                setLayerList(tmpLayerList);
            }
        };
        window.addEventListener('keyup', handleKeyUp);
        return () => {
            window.removeEventListener('keyup', handleKeyUp);
        };
    }, []);
    // 레이어 체크 혹은 헤제 하면 호출된다
    React.useEffect(() => {
        const map = mapRef.current
        if (!map) { return; }
        // 자율주행노선 자율주행차량 map.setView()
        if (selectedLayer?.layer === 'selfLinkLayer'
            || selectedLayer?.layer === 'selfVhcLayer') {
            if (selectedLayer?.checked) {
                map.SetMapView(17, 127.05504, 37.28995);
            } else {
                // map.SetMapView(13.5, 127.03804, 37.2695);
                if (map) { map.SetMapView(13.5, 127.00454, 37.28195); }
            }
        }

        if (selectedLayer?.layer === 'busHeatLayerGetOn'
            || selectedLayer?.layer === 'busHeatLayerGetOff') {
            if (allLayerList.find(x => x.layer === 'busHeatLayerGetOn')?.checked
                && allLayerList.find(x => x.layer === 'busHeatLayerGetOff')?.checked) {
                map.SetLayerVisible('busHeatLayerGetOn', false);
                map.SetLayerVisible('busHeatLayerGetOff', false);
                map.SetLayerVisible('busHeatLayer', true);
            } else if (allLayerList.find(x => x.layer === 'busHeatLayerGetOn')?.checked) {
                map.SetLayerVisible('busHeatLayerGetOn', true);
                map.SetLayerVisible('busHeatLayerGetOff', false);
                map.SetLayerVisible('busHeatLayer', false);
            } else if (allLayerList.find(x => x.layer === 'busHeatLayerGetOff')?.checked) {
                map.SetLayerVisible('busHeatLayerGetOn', false);
                map.SetLayerVisible('busHeatLayerGetOff', true);
                map.SetLayerVisible('busHeatLayer', false);
            } else {
                map.SetLayerVisible('busHeatLayerGetOn', false);
                map.SetLayerVisible('busHeatLayerGetOff', false);
                map.SetLayerVisible('busHeatLayer', false);
            }
        }

    }, [selectedLayer, selectedLayer?.checked]);

    const handleClick = (e, i) => {
        setMenu(i);
        stopPlayback();
    }

    const setMenu = (i) => {
        setLayerIndex(i);
        setSelLayerList(layerList[i]);

        const map = mapRef.current
        // if(map) { map.SetMapView(13.5, 127.03804, 37.2695); }
        if (map) { map.SetMapView(13.5, 127.00454, 37.28195); }

        if ( i < 4){
            setVideoOpen(false);
        }
    }

    const handleChangeDate = (event) => {
        setTimerDate(event.target.value);
        stopPlayback();
    };

    // 도로소통히트맵 재생
    const startPlayback = () => {
        if (timerRef.current) return;

        timerRef.current = setInterval(() => {
            setCurrentTimeIndex((prev) => {
                const next = prev + 1;

                if (next > 23) {
                    clearInterval(timerRef.current);
                    timerRef.current = null;
                    setTimerPlaying(false);
                    setCurrentTimeIndex(0);
                    return 23;
                }
                return next;
            });
        }, 1000);

        setTimerPlaying(true);
    };

    // 도로소통히트맵 pause
    const pausePlayback = () => {
        if (timerRef.current) {
            clearInterval(timerRef.current);
            timerRef.current = null;
        }
        setTimerPlaying(false);
    };

    // 도로소통히트맵 중지
    const stopPlayback = () => {
        clearInterval(timerRef.current);
        timerRef.current = null;
        setTimerPlaying(false);
        setCurrentTimeIndex(0);
    };

    const handleClickEmergency = async (id) => {
        await ApiService.get(`testMode/ToggleEmergencyVehicleEmulator?id=${id ?? 0}`)
            .then(response => {
                if (response.status === 200) {
                    const data = response.data;
                    if (data.running) {
                        setOpen({ message: '긴급차량 에뮬레이터 성공', open: true, severity: 'success' });
                    } else {
                        setOpen({ message: '긴급차량 에뮬레이터 중지', open: true, severity: 'info' });
                    }
                }
            });
    };

    const handleCloseEmergency = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpen(false);
    };

    const handleClickSelfVehicle = async (id) => {
        await ApiService.get(`newdashboard/ftrtrf/GetSelfDrivingEmulator?EmulatorMode=${id}`)
            .then(response => {
                if (response.status === 200) {
                    const data = response.data;
                    console.log(data)

                    if (id === 'Y') {
                        setVideoOpen(true);
                    } else if (id === 'N') {
                        setVideoOpen(false);
                    }
                }
            });
    };

    return (
        <div className={`${styles.container_gis}`} style={{ width: "100%", height: "100%", background: "var(--bg-gradient)", }}>
            <div style={{ position: 'relative', height: '100%', width: '100%', padding: '60px 0', borderRadius: '40px', display: 'grid' }}>
                <DashboardMap
                    ref={mapRef}
                    initViewData={{ zoom: 15, center: [127.0480244, 37.2993926] }}
                    link2GeoJson={link2GeoJson}
                    vehicleItems={vehicleItems}
                    passengerData={passengerData}
                    inOutTrfData={inOutTrfData}
                    hazaData={hazaData}
                    currentLink2Data={currentLink2Data}
                    allLayerList={allLayerList}
                    timerIndex={timerIndex}
                    timerDate={timerDate}
                    setLoaded1={setLoaded1}
                    setLoaded2={setLoaded2}
                    setLoaded3={setLoaded3}
                />
            </div>
            {/* 도로소통 */}
            {allLayerList.find(x => x.layer === 'linkLayer')?.checked ?
                <div>
                    <TrafficColorTableBox sx={{ position: 'absolute', left: '20px', bottom: '90px', }} />
                </div>
                : ''}
            {/* 긴급차량 */}
            <Stack direction="row" spacing={2} sx={{ position: 'absolute', bottom: 0, right: 0, m: 2 }}>
                {Object.entries(emergencyVehicleArr).map(keyVal => <EmergencyVehicleInfoBox key={keyVal[0]} {...keyVal[1]} />)}
            </Stack>
            {/* GIS checkbox 메뉴 */}
            <div className={`${styles.mapBtn_gis}`}>
                {['mapTrfBtn', 'mapSgnlBtn', 'mapBisBtn', 'mapSafeBtn', 'mapFclBtn'].map((item, index) => (
                    <div
                        key={index}
                        className={`${styles[item]} ${layerIndex === index ? styles.on : ''}`}
                        onClick={(e) => handleClick(e, index)}>
                    </div>
                ))}
            </div>
            {/* GIS checkbox 메뉴 */}
            <GisLayerCheck selLayerList={selLayerList} setLayerList={setSelLayerList} layerIndex={layerIndex} allLayerList={allLayerList} setAllLayerList={setAllLayerList} setSelectedLayer={setSelectedLayer} />
            {/* 버스차량 */}
            {allLayerList.find(x => x.layer === 'busLayer')?.checked ?
                <Paper
                    variant='outlined'
                    sx={{ position: 'absolute', left: 0, bottom: 0, m: 2, backgroundColor: defColors.backgroundColor, marginBottom: 10, }}>
                    <Stack
                        alignItems={'start'} justifyContent={'center'}
                        divider={<Divider orientation="horizontal" flexItem />}
                        spacing={1}
                        sx={{ p: 2, pt: 1, pb: 1 }}
                    >
                        <ColorInfoItem text={`광역버스 `} color={defColors.bus.code14} />
                        <ColorInfoItem text={`시내버스 `} color={defColors.bus.code13} />
                        <ColorInfoItem text={`마을버스 `} color={defColors.bus.code30} />
                    </Stack>
                </Paper>
                : ''}
            {/* 히트맵 slidebar */}
            {allLayerList.find(x => x.layer === 'linkHeatLayer')?.checked
                || allLayerList.find(x => x.layer === 'busHeatLayer')?.checked
                || allLayerList.find(x => x.layer === 'busHeatLayerGetOn')?.checked
                || allLayerList.find(x => x.layer === 'busHeatLayerGetOff')?.checked ?
                <Paper
                    variant='outlined'
                    sx={{ position: 'absolute', left: '50%', top: '100px', transform: 'translateX(-50%)', m: 2, backgroundColor: 'var(--black)', }}>
                    <Stack
                        alignItems={'start'} justifyContent={'center'}
                        divider={<Divider orientation="horizontal" flexItem />}
                        spacing={1}
                        sx={{ p: 2, pt: 1, pb: 1 }}
                    >
                        <div className='flx a_cemter' style={{ width: '1200px', fontSize: '18px', padding: '4px 10px', borderRadius: '6px' }}>
                            <div className={`${styles.date}`}><input type="date" defaultValue={getToday()} onChange={handleChangeDate} /></div>
                            <IconButton onClick={startPlayback} disabled={timerPlaying} >
                                <PlayArrowIcon />
                            </IconButton>
                            <IconButton onClick={pausePlayback} disabled={!timerPlaying} >
                                <PauseIcon />
                            </IconButton>
                            <IconButton onClick={stopPlayback} disabled={!timerPlaying} >
                                <StopIcon />
                            </IconButton>
                            <Slider value={timerIndex} min={0} max={23}
                                onChange={(e, newValue) => setCurrentTimeIndex(Number(newValue))}
                                sx={{ mx: 3, padding: '16px 0', }}
                            />
                            <div style={{ width: '60px', fontSize: '18px', marginTop: '4px' }}>{timerIndex + ' 시'}</div>
                        </div>
                    </Stack>
                </Paper>
                : ''}
            {/* 긴급차량 에뮬레이터 */}
            {allLayerList.find(x => x.layer === 'emerLayer')?.checked ?
                <Paper
                    variant='outlined'
                    sx={{ position: 'absolute', left: 0, bottom: 64, m: 2, backgroundColor: defColors.backgroundColor, marginBottom: 10, }}>
                    <Stack
                        alignItems={'start'} justifyContent={'center'}
                        divider={<Divider orientation="horizontal" flexItem />}
                        spacing={1}
                        sx={{ p: 2, pt: 1, pb: 1 }}
                    >
                        <Item variant='outlined' onClick={() => handleClickEmergency(1)}>긴급차량 에뮬레이터1</Item>
                        <Item variant='outlined' onClick={() => handleClickEmergency(2)}>긴급차량 에뮬레이터2</Item>
                        <Item variant='outlined' onClick={() => handleClickEmergency(3)}>긴급차량 에뮬레이터3</Item>
                        <Item variant='outlined' onClick={() => handleClickEmergency(4)}>긴급차량 에뮬레이터4</Item>
                        <Item variant='outlined' onClick={() => handleClickEmergency(5)}>긴급차량 에뮬레이터5</Item>
                        <Snackbar open={open.open} autoHideDuration={3000} onClose={handleCloseEmergency}>
                            <Alert onClose={handleCloseEmergency} severity={open.severity} sx={{ width: '100%' }}>
                                {open.message}
                            </Alert>
                        </Snackbar>
                    </Stack>
                </Paper>
                : ''}
            {/* 히트맵로딩딩 */}
            {(allLayerList.find(x => x.layer === 'busHeatLayerGetOn')?.checked
                && allLayerList.find(x => x.layer === 'busHeatLayerGetOff')?.checked && !loaded1)
                || (allLayerList.find(x => x.layer === 'busHeatLayerGetOn')?.checked && !loaded2)
                || (allLayerList.find(x => x.layer === 'busHeatLayerGetOff')?.checked && !loaded3) ?
                <div
                    style={{ position: 'absolute', left: '50%', top: '40%', transform: 'translateX(-50%)', m: 2, }}>
                    <Stack
                        alignItems={'start'} justifyContent={'center'}
                        divider={<Divider orientation="horizontal" flexItem />}
                        spacing={1}
                        sx={{ p: 2, pt: 1, pb: 1 }}
                    >
                        <Spinner />
                    </Stack>
                </div>
                : ''}
            {/* 자율주행 에뮬레이터 */}
            {allLayerList.find(x => x.layer === 'selfVhcEmulator')?.checked ?
                <Paper
                    variant='outlined'
                    sx={{ position: 'absolute', left: 0, bottom: 64, m: 2, backgroundColor: defColors.backgroundColor, marginBottom: 10, }}>
                    <Stack
                        alignItems={'start'} justifyContent={'center'}
                        divider={<Divider orientation="horizontal" flexItem />}
                        spacing={1}
                        sx={{ p: 2, pt: 1, pb: 1 }}
                    >
                        <Item variant='outlined' onClick={() => handleClickSelfVehicle('Y')}>자율주행 에뮬레이터 시작</Item>
                        <Item variant='outlined' onClick={() => handleClickSelfVehicle('N')}>자율주행 에뮬레이터 종료</Item>
                        <Snackbar open={open.open} autoHideDuration={3000} onClose={handleCloseEmergency}>
                            <Alert onClose={handleCloseEmergency} severity={open.severity} sx={{ width: '100%' }}>
                                {open.message}
                            </Alert>
                        </Snackbar>
                    </Stack>
                </Paper>
                : ''}
            {videoOpen && (
                <div className={`${styles.autoVehCctvWrap}`}>
                    <div></div> {/*  빈박스 영역 - 비워두면돼요 */}
                    <div><video src="/video/cctv1.mp4" autoPlay muted> </video></div> {/*  빈박스 영역 - 가운데상단영역 비디오 넣어주세요 */}
                    <div></div>{/*  빈박스 영역 - 비워두면돼요 */}
                    <div><video src="/video/cctv2.mp4" autoPlay muted> </video></div>
                    <div></div>{/*  빈박스 영역 - 비워두면돼요 */}
                    <div><video src="/video/cctv3.mp4" autoPlay muted> </video></div>
                    <div><video src="/video/cctv4.mp4" autoPlay muted> </video></div>
                    <div></div>{/*  빈박스 영역 - 비워두면돼요 */}
                    <div><video src="/video/cctv5.mp4" autoPlay muted> </video></div>
                </div>
            )}
        </div>
    )
}

const ColorInfoItem = ({ color, text }) => {
    return (
        <Stack direction={'row'} alignItems={'center'} justifyContent={'start'} spacing={1.5}>
            <Box sx={{ width: 24, height: 14, backgroundColor: color }} />
            <Typography variant='h5'>{text}</Typography>
        </Stack>
    )
}

const getYesterday = () => {
    const today = new Date();
    today.setDate(today.getDate() - 1);
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const dd = String(today.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
};

const getToday = () => {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const dd = String(today.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
};